import { UserRole } from './roles.enum';
import { AppFeature } from './features.enum';

export const RoleAccessMap: Record<AppFeature, UserRole[]> = {
    [AppFeature.Dashboard]: [UserRole.Manager, UserRole.SuperUser],
    [AppFeature.UserDashboard]: [UserRole.SalesPerson],
    [AppFeature.ManageOrders]: [UserRole.Manager, UserRole.SalesPerson, UserRole.SuperUser, UserRole.ReadOnly],
    [AppFeature.CreateOrder]: [UserRole.Manager, UserRole.SuperUser],
    [AppFeature.UserManagement]: [UserRole.Manager, UserRole.SuperUser],
    [AppFeature.Reports]: [UserRole.Manager, UserRole.SuperUser],
    [AppFeature.ProfileSettings]: [UserRole.Manager, UserRole.SuperUser],
    [AppFeature.UserProfile]: [UserRole.SalesPerson],
    [AppFeature.Target]: [UserRole.Manager, UserRole.SuperUser],
    [AppFeature.RootwisePickingList]: [UserRole.Manager, UserRole.SuperUser],
    [AppFeature.Monitoring]: [UserRole.SuperUser],
    [AppFeature.CustomerPortalUsers]: [UserRole.SuperUser],
    [AppFeature.CustomerSupportView]: [UserRole.SuperUser]
};
